require('./bootstrap');

// Font Awesome
import fontawesome from '@fortawesome/fontawesome-pro/js/fontawesome'
import brands from '@fortawesome/fontawesome-pro/js/brands'
import solid from '@fortawesome/fontawesome-pro/js/solid'
import light from '@fortawesome/fontawesome-pro/js/light'
import thin from '@fortawesome/fontawesome-pro/js/thin'

// Common libraries
require('aos/dist/aos.js');
require('fslightbox');
import flatpickr from "flatpickr";
const Deutsch = require("flatpickr/dist/l10n/de.js").default.de;
import moment from 'moment';

// Hamburger Icon Animation
var hamburger = document.querySelector(".hamburger");
// On click
hamburger.addEventListener("click", function() {
  // Toggle class "is-active"
  hamburger.classList.toggle("is-active");
  // open / close menu
});

// AOS
window.aos = require('aos');
aos.init({
	startEvent: 'DOMContentLoaded',
	easing: 'ease-in',
  delay: 600,
	once: false,
	mirror: true
});

// Contact Form: Date Input
$(function(){
  // enable date time picker
  var date = flatpickr("#datum_input", {
    enableTime: true,
    altInput: true,
    time_24hr: true,
    minDate: "today",
    altFormat: "j. F Y, H:i",
    dateFormat: "j F Y H:i",
    disable: [
      {
        from: "14 august 2000 13:00",
        to: moment(get_start_time()).subtract(1, "days").format('D MMMM YYYY HH:mm')
      },
    ],
    minTime: "11:30",
    maxTime: "21:00",
    minuteIncrement: 15,
    allowInput: true,
    "locale": Deutsch,
    disableMobile: true,
    onOpen: function() {
      if ($('#datum_input').val() == '') date.setDate( get_start_time() );
    },
    onChange: function(obj, updatedTime) {
      if (moment(updatedTime).isValid()) {
        if (moment(updatedTime).isBefore( get_start_time() )) {
          date.setDate( get_start_time() );
        }
      }
    },
  });

  // ignore warning due to custom date time format
  moment.suppressDeprecationWarnings = true;


  function get_start_time() {
    // get current time to determine if time is in between allowed time for same day reservations
    var now = new Date();
    var hour = now.getHours();
    var minutes = now.getMinutes();
    var timeOfDay = hour + minutes / 100;
    // add 0 to one digit minutes
    if (minutes < 10) {
      minutes = "0" + minutes
    };

    // if user time is before opening time on same day, add 6 hours from opening time for earliest reservation time
    if (timeOfDay >= 0.00 && timeOfDay <= 11.30) {
      var start = moment().set('hour', 9).set('minute', 0).add(1,'hours');
      return moment(start).valueOf();
    }

    // if user time is within opening time, add 6 hours from current user time and round to nearest hour
    else if (timeOfDay >= 11.30 && timeOfDay <= 21.00) {
      var start = moment().add(1,'hours');
      var remainder = (60 - start.minute()) % 60;
      return moment(start).add(remainder,'minutes').valueOf();
    }

    // if user time is outside same day reservation windows, set to next day at beginning of opening time
    else {
      var startDay = moment().set('hour', 17).set('minute', 30).add(1,'days');
      return moment(startDay).valueOf();
    }
  }
});

// Success Message Overlay
if(document.getElementById('successArea')) {
	document.getElementById('successArea').addEventListener('click', function () {
	   this.classList.add('success-wrapper__hide');
	});
}

// Smooth scroll
(function() {
	scrollTo();
	//if(location.hash.length > 0) { // if von mir
    //    setTimeout(function() {
    //        document.querySelector('a' + location.hash).click();
    //    }, 500);
    //}
})();

function scrollTo() {
	var links = document.getElementsByTagName('a');
	for (var i = 0; i < links.length; i++) {
		var link = links[i];
		if ((link.href && link.href.indexOf('#') != -1) && ((link.pathname == location.pathname) || ('/' + link.pathname == location.pathname)) && (link.search == location.search)) {
			link.onclick = scrollAnchors;
		}
	}
}

function scrollAnchors(e, respond = null) {
	const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
	e.preventDefault();
	var targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');
	const targetAnchor = document.querySelector(targetID);
    //const targetAnchor = document.querySelector('a[name=' + targetID.substr(1) + ']'); //von Mir
	if (!targetAnchor) return;
	const originalTop = distanceToTop(targetAnchor);
	window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
	const checkIfDone = setInterval(function() {
		const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (distanceToTop(targetAnchor) === 0 || atBottom) {
			targetAnchor.tabIndex = '-1';
			//targetAnchor.focus();
			window.history.pushState('', '', targetID);
			clearInterval(checkIfDone);
		}
	}, 100);
}

// Get innerHeight
const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
}

window.addEventListener('resize', appHeight);

appHeight();

// 50 / 50 Split Animation
var Panels = (function() {
  
  var panelLeft = document.querySelector('.panels__side--left');
  var panelRight = document.querySelector('.panels__side--right');
  var panelFooter = document.querySelector('.footer');

  var openLeft = function() {
    panelLeft.classList.toggle('panels__side--left-active');
    panelRight.classList.toggle('panels__side--right-hidden');
    panelFooter.classList.toggle('show-bottom');
  };

  var openRight = function() {
    panelRight.classList.toggle('panels__side--right-active');
    panelLeft.classList.toggle('panels__side--left-hidden');
    panelFooter.classList.toggle('show-top');
  };
  
  var bindActions = function() {
    panelLeft.addEventListener('click', openLeft, false);
    panelRight.addEventListener('click', openRight, false);
  };
  
  var init = function() {
    bindActions();
  };
  
  return {
    init: init
  };
 
}());

Panels.init();

// Coded by unlimited.studio – https://unlimited.studio